import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6b8839ec = () => interopDefault(import('../pages/countries.vue' /* webpackChunkName: "pages/countries" */))
const _7daaea4a = () => interopDefault(import('../pages/help.vue' /* webpackChunkName: "pages/help" */))
const _b951de02 = () => interopDefault(import('../pages/no-subscription.vue' /* webpackChunkName: "pages/no-subscription" */))
const _54625cf6 = () => interopDefault(import('../pages/redirect.vue' /* webpackChunkName: "pages/redirect" */))
const _d9630146 = () => interopDefault(import('../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _2d5e7db0 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _adf4a604 = () => interopDefault(import('../pages/_countryCode.vue' /* webpackChunkName: "pages/_countryCode" */))
const _514ffd01 = () => interopDefault(import('../pages/_countryCode/index.vue' /* webpackChunkName: "pages/_countryCode/index" */))
const _7408420b = () => interopDefault(import('../pages/_countryCode/_disciplineCode.vue' /* webpackChunkName: "pages/_countryCode/_disciplineCode" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'hash',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/countries",
    component: _6b8839ec,
    name: "countries"
  }, {
    path: "/help",
    component: _7daaea4a,
    name: "help"
  }, {
    path: "/no-subscription",
    component: _b951de02,
    name: "no-subscription"
  }, {
    path: "/redirect",
    component: _54625cf6,
    name: "redirect"
  }, {
    path: "/terms",
    component: _d9630146,
    name: "terms"
  }, {
    path: "/",
    component: _2d5e7db0,
    name: "index"
  }, {
    path: "/:countryCode",
    component: _adf4a604,
    children: [{
      path: "",
      component: _514ffd01,
      name: "countryCode"
    }, {
      path: ":disciplineCode",
      component: _7408420b,
      name: "countryCode-disciplineCode"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
